import { Form } from '@mairistem/composants';
import _ from 'lodash';

interface InputNumberProps {
  maxLength: number;
  value: number;
  disabled: boolean;
  'data-testid': string;
  onChange: (value: string) => void;
  [x: string]: unknown;
}

const InputNumber = (props: InputNumberProps) => {
  const {
    maxLength,
    value: valueProps,
    disabled,
    inline = true,
    'data-testid': dataTestid,
    onChange,
    ...rest
  } = props;

  return (
    <Form.Input
      disabled={disabled}
      value={valueProps}
      label="Nombre"
      inline={inline}
      placeholder=""
      style={{ width: 50 }}
      type="number"
      min={0}
      onChange={(e, { value }) => _.size(value) <= maxLength && onChange(value)}
      onKeyDown={(evt) => ['e', 'E', '+', '-', '.', ','].includes(evt.key) && evt.preventDefault()}
      onFocus={(e) => {
        e.target.select();
      }}
      input={{ style: { textAlign: 'right' }, 'data-testid': dataTestid }}
      {...rest}
    />
  );
};

export default InputNumber;
